import {Action} from '@ngrx/store';
import {Price} from '../price.model';

export const GET_PRICING = 'GET_PRICING';
export const GET_PRICE = 'GET_PRICE';
export const SET_PRICING = 'SET_PRICING';
export const SET_PRICE = 'SET_PRICE';
export const GET_PRICING_PROFILE = 'GET_PRICING_PROFILE';
export const SET_PRICING_PROFILE = 'SET_PRICING_PROFILE';
export const GET_PRICING_TIME = 'GET_PRICING_TIME';
export const SET_PRICING_TIME = 'SET_PRICING_TIME';
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const CREATE_PAYMENT_STRIPE = 'CREATE_PAYMENT_STRIPE';
export const GET_PAYMENT_DETAIL = 'GET_PAYMENT_DETAIL';
export const SET_PAYMENT_DETAIL = 'SET_PAYMENT_DETAIL';
export const SET_PAYMENT_LOADER = 'SET_PAYMENT_LOADER';
export const CREATE_PAYMENT_SUBSCRIPTION_STRIPE = 'CREATE_PAYMENT_SUBSCRIPTION_STRIPE';
export const TRACK_FACEBOOK_CONVERSION = 'TRACK_FACEBOOK_CONVERSION';

export class GetPricing implements Action {
  readonly type = GET_PRICING;

  constructor(public payload: {params: any}) {
  }
}

export class GetPricingTime implements Action {
  readonly type = GET_PRICING_TIME;

  constructor(public payload: {params: any}) {
  }
}

export class GetPrice implements Action {
  readonly type = GET_PRICE;

  constructor(public payload: number) {}
}

export class GetPricingProfile implements Action {
  readonly type = GET_PRICING_PROFILE;

  constructor(public payload: number) {}
}

export class SetPricing implements Action {
  readonly type = SET_PRICING;

  constructor(public payload: Price[]) {}

}

export class SetPricingTime implements Action {
  readonly type = SET_PRICING_TIME;

  constructor(public payload: Price[]) {}

}

export class SetPrice implements Action {
  readonly type = SET_PRICE;

  constructor(public payload: Price) {}

}

export class SetPricingProfile implements Action {
  readonly type = SET_PRICING_PROFILE;

  constructor(public payload: Price[]) {}

}

export class CreatePayment implements Action {
  readonly type = CREATE_PAYMENT;

  constructor(public payload: number) {}
}

export class CreatePaymentStripe implements Action {
  readonly type = CREATE_PAYMENT_STRIPE;

  constructor(public payload: {
    id: number,
    token: string
  }) {}
}

export class CreatePaymentSubscriptionStripe implements Action {
  readonly type = CREATE_PAYMENT_SUBSCRIPTION_STRIPE;

  constructor(public payload: {
    id: number,
    params: any
  }) {}
}

export class GetPaymentDetails implements Action {
  readonly type = GET_PAYMENT_DETAIL;

  constructor(public payload: number) {
  }
}

export class SetPaymentDetails implements Action {
  readonly type = SET_PAYMENT_DETAIL;

  constructor(public payload: any) {
  }
}

export class SetPaymentLoader implements Action {
  readonly type = SET_PAYMENT_LOADER;

  constructor(public payload: {name: string, value: boolean}) {}
}

export class TrackFacebookConversion implements Action {
  readonly type = TRACK_FACEBOOK_CONVERSION;

  constructor(public payload: number) {}
}

export type PaymentActions = GetPricing | GetPrice | SetPrice | SetPricing | CreatePayment | GetPaymentDetails | SetPaymentDetails
  | CreatePaymentStripe | SetPaymentLoader | CreatePaymentSubscriptionStripe
  | GetPricingProfile | SetPricingProfile | GetPricingTime | SetPricingTime
  | TrackFacebookConversion
  ;
